import {
  cn,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@atlant/ui"

import { formatAmount } from "#utils/money.ts"

import type { InboxInvoice } from "../page.tsx"
import { InvoiceTypeBadge } from "./invoice-type-badge.tsx"

interface CategoryInvoicesProps {
  invoices: InboxInvoice[]
  selectedId?: string
  onSelect: (invoiceId: string) => void
}

export const CategoryInvoices = ({
  invoices,
  selectedId,
  onSelect,
}: CategoryInvoicesProps) => (
  <div>
    <Table className="text-xs">
      <TableHeader>
        <TableRow className="text-xs uppercase hover:bg-transparent">
          <TableHead className="text-muted-foreground h-8 text-xs font-medium">
            PUR number
          </TableHead>
          <TableHead className="text-muted-foreground h-8 w-full text-xs font-medium">
            Vendor
          </TableHead>
          <TableHead className="text-muted-foreground h-8 text-xs font-medium">
            Invoice date
          </TableHead>
          <TableHead className="text-muted-foreground h-8 text-right text-xs font-medium">
            Amount, €
          </TableHead>
          <TableHead className="text-muted-foreground h-8 text-xs font-medium">
            Status
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {invoices.map((invoice) => {
          const isSelected = invoice.id === selectedId
          return (
            <TableRow
              key={invoice.id}
              tabIndex={0}
              aria-selected={isSelected}
              onClick={() => onSelect(invoice.id)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  onSelect(invoice.id)
                }
              }}
              className={cn(
                "focus-visible:bg-muted cursor-pointer border-none outline-none",
                isSelected && "bg-primary/10 hover:bg-primary/10",
              )}
            >
              <TableCell
                className={cn(
                  "border-none py-1.5",
                  // The row's edge takes its status color, as in the design
                  invoice.type === "LATE" &&
                    "shadow-[inset_3px_0_0_var(--color-fuchsia-500)] dark:shadow-[inset_3px_0_0_var(--color-fuchsia-400)]",
                )}
              >
                {invoice.number}
              </TableCell>
              {/* Takes what the other columns leave and truncates, so Status stays in view */}
              <TableCell
                title={invoice.vendor}
                className="w-full max-w-0 truncate border-none py-1.5"
              >
                {invoice.vendor}
              </TableCell>
              <TableCell className="border-none py-1.5">
                {invoice.invoiceDate.displaydate}
              </TableCell>
              <TableCell className="border-none py-1.5 text-right font-medium">
                {formatAmount(
                  invoice.total,
                  invoice.currency === "EUR" ? undefined : invoice.currency,
                )}
              </TableCell>
              <TableCell className="border-none py-1.5">
                <InvoiceTypeBadge invoice={invoice} />
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  </div>
)
